// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__wHhy7","loader":"styles_loader__2PFu_","errorContainer":"styles_errorContainer__1qQyc"};